import { render, staticRenderFns } from "./textSk.vue?vue&type=template&id=225a0236&"
import script from "./textSk.vue?vue&type=script&lang=js&"
export * from "./textSk.vue?vue&type=script&lang=js&"
import style0 from "./textSk.vue?vue&type=style&index=0&id=225a0236&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports